/**
 * Format Phone
 * for example: (234) 567 8910
 *
 * @param {string} phone
 * @param {string} defaultValue
 * @return {string}
 */
export const formatPhone = (phone, defaultValue = '') =>
  phone
    ? phone
        .replace(/\D/gm, '')
        .slice(0, 11)
        .replace(/(\d{3}|\d{2}|\d{1})?(\d{3}|\d{2}|\d{1})?(\d{4}|\d{3}|\d{2}|\d{1})?/gm, (fullMatch, $1, $2, $3) => {
          if ($3) {
            return `(${$1}) ${$2} ${$3}`
          }

          if ($2) {
            return `(${$1}) ${$2}`
          }

          if ($1) {
            return `${$1}`
          }

          return ''
        })
    : defaultValue
